import React from 'react';
import { Field, reduxForm } from 'redux-form/immutable';
import PropTypes from 'prop-types';
import NavbarModulo from '../../components/NavbarModulo';

import {
    renderField,
} from "../../Utils/renderField/renderField";

function PersonalExternoForm(props) {
    const { handleSubmit, crear, modulo, paisN } = props;
    
    const editar = window.location.href.includes('editar');
    let titulo = editar ? 'Modificar personal externo' : 'Crear personal externo';
    let disabled = false;
    if (crear === false && editar === false) {
        disabled = true;
        titulo = 'Ver personal externo'
    }
    let autoFocus = true;
    let ruta = window.location.href;
    let id_emp = ruta.split('/');
    return (
        <div>
            <NavbarModulo
                pais={paisN}
                modulo={modulo}
                titulo={titulo}
            />
            <form onSubmit={handleSubmit}>
                <br />
                <div className="mb-4 card card-small text-white bg-dark mb-3">
                    <div className="p-0 pt-3 d-flex flex-column flex-md-row">
                        <div className="d-flex flex-column flex-1 mx-4">
                            <div className='mb-2 row'>
                                <div className='col-6'>
                                    <Field
                                        autoFocus={autoFocus}
                                        name="nombre"
                                        placeholder="Nombre"
                                        className="form-control"
                                        component={renderField}
                                        disabled={disabled}
                                        msj="Nombre"
                                    />
                                </div>
                                <div className='col-6'>
                                    <Field
                                        name="puesto"
                                        placeholder="Puesto"
                                        className="form-control"
                                        component={renderField}
                                        disabled={disabled}
                                        msj="Puesto"
                                    />
                                </div>
                            </div>
                            <div className='d-flex flex-row mt-3'>
                                {disabled == false &&
                                    <button
                                        className='btn mr-2 mb-3 btn-primary'
                                        type='submit'
                                    >
                                        {editar ? 'Modificar' : 'Guardar'}
                                    </button>
                                }
                                <a
                                    href={`/#/visitador_medico/${id_emp[5]}/personal_externo/${id_emp[8]}`}
                                    className='btn btn-secondary mb-3'
                                >
                                    Regresar
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
            </form>
        </div>
    );
}

PersonalExternoForm.propTypes = {
    handleSubmit: PropTypes.func,
    crear: PropTypes.bool,
    lectura: PropTypes.object,
    modulo: PropTypes.object,
};

export default reduxForm({
    form: 'FormPersonalExternoVM',
})(PersonalExternoForm);
